import { Id, Identifiable, ProjectReport } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function findReport(reportId: Id, reports: Identifiable<ProjectReport>[]) {
  return reports.find((report) => report.uuid === reportId);
}

function createInteractor(repository: Repository): Interactor {
  return ({ project, reportId }) =>
    present(
      repository
        .getProjectReports(project)
        .then((reports) => findReport(reportId, reports))
        .then((report) =>
          report ? { report, project } : Promise.reject({ project, reportId }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
